import React, { useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { APPLY_ROUTE, LOGIN_ROUTE, withBase } from '../../publicSite/config';
import { trackEvent } from '../../publicSite/analytics';

const links = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Academics', to: '/academics/faculties' },
  { label: 'Admissions', to: '/admissions' },
  { label: 'Events', to: '/events' }
];

export default function MobileMenuDrawer({ open, onClose }) {
  const drawerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const focusable = () => Array.from(drawerRef.current?.querySelectorAll('a[href], button:not([disabled])') || []);
    const handleKeyDown = (event) => {
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    window.setTimeout(() => focusable()[0]?.focus(), 0);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  return (
    <nav
      ref={drawerRef}
      id="public-mobile-navigation"
      className={`ps-mobile-drawer ${open ? 'is-open' : ''}`}
      aria-label="Mobile navigation"
      aria-hidden={!open}
    >
      <div className="ps-mobile-primary">
        {links.map((link) => (
          <NavLink
            key={link.label}
            to={withBase(link.to)}
            end={link.to === '/'}
            className={({ isActive }) => (isActive ? 'is-active' : '')}
            onClick={() => onClose(false)}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
      <div className="ps-mobile-actions">
        <Link
          to={withBase(LOGIN_ROUTE)}
          className="btn btn-outline"
          onClick={() => { trackEvent('cta_click', { label: 'mobile_login' }); onClose(false); }}
        >
          Sign In
        </Link>
        <Link
          to={withBase(APPLY_ROUTE)}
          className="btn btn-primary"
          onClick={() => { trackEvent('cta_click', { label: 'mobile_apply' }); onClose(false); }}
        >
          Apply
        </Link>
      </div>
    </nav>
  );
}
